import { callApi } from "Apis";
import { QRTEMPLATEURL } from "helpers/constant";

// Fetch Qr Template List API function
export async function fetchQrTemplateListApi(data) {
  try {
    const response = await callApi({ url: QRTEMPLATEURL.LIST, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}
// Add Qr Template API function
export async function addQrTemplateApi(payload) {
  try {
    const response = await callApi({ url: QRTEMPLATEURL.ADD, body: payload, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

// function to delete Qr Template API function
export async function deleteQrTemplateApi(id) {
  try {
    const response = await callApi({ url: QRTEMPLATEURL.DELETE(id), method: "DELETE" });
    return response;
  } catch (err) {
    throw err;
  }
}
// Update Qr Template API function
export async function updateQrTemplateApi(data) {
  try {
    const response = await callApi({ url: QRTEMPLATEURL.UPDATE, body: data, method: "PUT" });
    return response;
  } catch (err) {
    throw err;
  }
}

// Edit Qr Template API function
export async function getQrTemplateByIdApi(id) {
  try {
    const response = await callApi({ url: QRTEMPLATEURL.GET(id), method: "GET" });
    return response;
  } catch (err) {
    throw err;
  }
}
